export default __webpack_public_path__ + "static/media/des4.80abb53e.jpeg";